import useSWRInfinite from 'swr/infinite'

import { paths } from 'routes/paths'
import resumeFolders from 'api/courses/resumeFolders'
import Loader from 'components/ui/loader/Loader'
import { useElementVisible } from 'hooks/useScrollFetch'
import { Folder } from './Folder'

export const Folders = ({ search }: { search: string }) => {
  const { data, isLoading, setSize, isValidating, size } = useSWRInfinite(
    (index) => ({
      page: index + 1,
      search,
    }),
    async ({ page, search }) =>
      resumeFolders({
        page: page,
        perPage: 3,
        search,
      })
  )

  const isLoadingMore =
    isLoading || (size > 0 && data && typeof data[size - 1] === 'undefined')
  const loading = isLoading || isLoadingMore

  const { elementRef } = useElementVisible({
    onVisible: async () => {
      if (loading || isValidating) return

      if (data) {
        const last = data[data.length - 1]
        if (!last.length) return
      }
      setSize((size) => size + 1)
    },
  })

  return (
    <div>
      {data?.flat()?.map((folder) => (
        <Folder
          href={paths.home.folder.details(folder.id, folder.name)}
          key={folder.id}
          name={folder.name}
          courses={folder.courses}
          totalCourses={folder.totalCourses}
        />
      ))}
      <div ref={elementRef} />
      {loading && <Loader color />}
    </div>
  )
}
